export const COLORS = {
  "main-yellow": "#FCE78A",
  "main-black": "#282828",
  "main-green": "#1EB764",
  "secondary-blue": "#41465F",
  "third-blue": "#2F3549",
  "main-blue": "#030C18",
  "main-brown": "#644848",
  "main-gray": "#AF9A9A",
  "main-blue-rgba": (alpha) => `rgba(3,12,24,${alpha})`,
};
